/**
 * 2026 FIFA World Cup edition.
 *
 * Hosts: USA, Canada, Mexico. First 48-team World Cup.
 * Group stage: 11 June 2026 (opener at Estadio Azteca, Mexico City).
 * Final: 19 July 2026 (MetLife Stadium, New Jersey).
 *
 * Team list is the historical hard-coded roster from `server/teams.ts`.
 * IDs match football-data.org team IDs.
 */

import type { Edition } from "./types";

export const edition2026: Edition = {
  year: 2026,
  hostNations: ["USA", "Canada", "Mexico"],
  startDate: "2026-06-11",
  endDate: "2026-07-19",
  teams: [
    // Group A
    { id: 769,  name: "Mexico",               code: "MEX", flag: "🇲🇽", group: "A", confederation: "CONCACAF" },
    { id: 774,  name: "South Africa",         code: "RSA", flag: "🇿🇦", group: "A", confederation: "CAF" },
    { id: 772,  name: "South Korea",          code: "KOR", flag: "🇰🇷", group: "A", confederation: "AFC" },
    { id: 798,  name: "Czechia",              code: "CZE", flag: "🇨🇿", group: "A", confederation: "UEFA" },
    // Group B
    { id: 828,  name: "Canada",               code: "CAN", flag: "🇨🇦", group: "B", confederation: "CONCACAF" },
    { id: 1060, name: "Bosnia-Herzegovina",   code: "BIH", flag: "🇧🇦", group: "B", confederation: "UEFA" },
    { id: 8030, name: "Qatar",                code: "QAT", flag: "🇶🇦", group: "B", confederation: "AFC" },
    { id: 788,  name: "Switzerland",          code: "SUI", flag: "🇨🇭", group: "B", confederation: "UEFA" },
    // Group C
    { id: 764,  name: "Brazil",               code: "BRA", flag: "🇧🇷", group: "C", confederation: "CONMEBOL" },
    { id: 815,  name: "Morocco",              code: "MAR", flag: "🇲🇦", group: "C", confederation: "CAF" },
    { id: 836,  name: "Haiti",                code: "HAI", flag: "🇭🇹", group: "C", confederation: "CONCACAF" },
    { id: 8873, name: "Scotland",             code: "SCO", flag: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", group: "C", confederation: "UEFA" },
    // Group D
    { id: 771,  name: "United States",        code: "USA", flag: "🇺🇸", group: "D", confederation: "CONCACAF" },
    { id: 761,  name: "Paraguay",             code: "PAR", flag: "🇵🇾", group: "D", confederation: "CONMEBOL" },
    { id: 779,  name: "Australia",            code: "AUS", flag: "🇦🇺", group: "D", confederation: "AFC" },
    { id: 803,  name: "Turkey",               code: "TUR", flag: "🇹🇷", group: "D", confederation: "UEFA" },
    // Group E
    { id: 759,  name: "Germany",              code: "GER", flag: "🇩🇪", group: "E", confederation: "UEFA" },
    { id: 9460, name: "Curaçao",              code: "CUW", flag: "🇨🇼", group: "E", confederation: "CONCACAF" },
    { id: 1935, name: "Ivory Coast",          code: "CIV", flag: "🇨🇮", group: "E", confederation: "CAF" },
    { id: 791,  name: "Ecuador",              code: "ECU", flag: "🇪🇨", group: "E", confederation: "CONMEBOL" },
    // Group F
    { id: 8601, name: "Netherlands",          code: "NED", flag: "🇳🇱", group: "F", confederation: "UEFA" },
    { id: 766,  name: "Japan",                code: "JPN", flag: "🇯🇵", group: "F", confederation: "AFC" },
    { id: 792,  name: "Sweden",               code: "SWE", flag: "🇸🇪", group: "F", confederation: "UEFA" },
    { id: 802,  name: "Tunisia",              code: "TUN", flag: "🇹🇳", group: "F", confederation: "CAF" },
    // Group G
    { id: 805,  name: "Belgium",              code: "BEL", flag: "🇧🇪", group: "G", confederation: "UEFA" },
    { id: 825,  name: "Egypt",                code: "EGY", flag: "🇪🇬", group: "G", confederation: "CAF" },
    { id: 840,  name: "Iran",                 code: "IRN", flag: "🇮🇷", group: "G", confederation: "AFC" },
    { id: 783,  name: "New Zealand",          code: "NZL", flag: "🇳🇿", group: "G", confederation: "OFC" },
    // Group H
    { id: 760,  name: "Spain",                code: "ESP", flag: "🇪🇸", group: "H", confederation: "UEFA" },
    { id: 1930, name: "Cape Verde",           code: "CPV", flag: "🇨🇻", group: "H", confederation: "CAF" },
    { id: 801,  name: "Saudi Arabia",         code: "KSA", flag: "🇸🇦", group: "H", confederation: "AFC" },
    { id: 758,  name: "Uruguay",              code: "URU", flag: "🇺🇾", group: "H", confederation: "CONMEBOL" },
    // Group I
    { id: 773,  name: "France",               code: "FRA", flag: "🇫🇷", group: "I", confederation: "UEFA" },
    { id: 804,  name: "Senegal",              code: "SEN", flag: "🇸🇳", group: "I", confederation: "CAF" },
    { id: 8062, name: "Iraq",                 code: "IRQ", flag: "🇮🇶", group: "I", confederation: "AFC" },
    { id: 8872, name: "Norway",               code: "NOR", flag: "🇳🇴", group: "I", confederation: "UEFA" },
    // Group J
    { id: 762,  name: "Argentina",            code: "ARG", flag: "🇦🇷", group: "J", confederation: "CONMEBOL" },
    { id: 778,  name: "Algeria",              code: "ALG", flag: "🇩🇿", group: "J", confederation: "CAF" },
    { id: 816,  name: "Austria",              code: "AUT", flag: "🇦🇹", group: "J", confederation: "UEFA" },
    { id: 8049, name: "Jordan",               code: "JOR", flag: "🇯🇴", group: "J", confederation: "AFC" },
    // Group K
    { id: 765,  name: "Portugal",             code: "POR", flag: "🇵🇹", group: "K", confederation: "UEFA" },
    { id: 1934, name: "Congo DR",             code: "COD", flag: "🇨🇩", group: "K", confederation: "CAF" },
    { id: 8070, name: "Uzbekistan",           code: "UZB", flag: "🇺🇿", group: "K", confederation: "AFC" },
    { id: 818,  name: "Colombia",             code: "COL", flag: "🇨🇴", group: "K", confederation: "CONMEBOL" },
    // Group L
    { id: 770,  name: "England",              code: "ENG", flag: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", group: "L", confederation: "UEFA" },
    { id: 799,  name: "Croatia",              code: "CRO", flag: "🇭🇷", group: "L", confederation: "UEFA" },
    { id: 763,  name: "Ghana",                code: "GHA", flag: "🇬🇭", group: "L", confederation: "CAF" },
    { id: 1836, name: "Panama",               code: "PAN", flag: "🇵🇦", group: "L", confederation: "CONCACAF" },
  ],
};
